export var ScheduleChangeFlow;
(function (ScheduleChangeFlow) {
    ScheduleChangeFlow["MoveToQueue"] = "MoveToQueue";
    ScheduleChangeFlow["ReferToAirline"] = "ReferToAirline";
})(ScheduleChangeFlow || (ScheduleChangeFlow = {}));
export var ScheduleChangeUserActionEnum;
(function (ScheduleChangeUserActionEnum) {
    ScheduleChangeUserActionEnum["Accept"] = "Accept";
    ScheduleChangeUserActionEnum["Deny"] = "Deny";
})(ScheduleChangeUserActionEnum || (ScheduleChangeUserActionEnum = {}));
export var ScheduleChangeSeverity;
(function (ScheduleChangeSeverity) {
    ScheduleChangeSeverity["Major"] = "Major";
    ScheduleChangeSeverity["Minor"] = "Minor";
    ScheduleChangeSeverity["Unknown"] = "Unknown";
})(ScheduleChangeSeverity || (ScheduleChangeSeverity = {}));
export var TimeGroupingEnum;
(function (TimeGroupingEnum) {
    TimeGroupingEnum[TimeGroupingEnum["EARLY_MORNING"] = 0] = "EARLY_MORNING";
    TimeGroupingEnum[TimeGroupingEnum["MORNING"] = 1] = "MORNING";
    TimeGroupingEnum[TimeGroupingEnum["AFTERNOON"] = 2] = "AFTERNOON";
    TimeGroupingEnum[TimeGroupingEnum["EVENING"] = 3] = "EVENING";
})(TimeGroupingEnum || (TimeGroupingEnum = {}));
//# sourceMappingURL=scheduleChange.js.map